export const countries = [
    {
      image: "/images/agri3.jpg",
      title: "Brazil",
    },
    {
      image: "/images/burning3.jpg",
      title: "France",
    },
    {
      image: "/images/burning4.jpg",
      title: "Japan",
    },
    {
      image: "/images/farm3.jpg",
      title: "Norway",
    },
  ];
  